import {ReportAnnualDegreeImprovement} from "../Models/ReportAnnualDegreeImprovement";
import {ReportTableTwo} from "../Models/ReportTableTwo";
import { ReportStatistical } from "@/Repositories/Reports/Models/ReportStatistical";

export class ReportModelFactory
{
    constructor(ReportType)
    {

        switch (ReportType)
        {
            case 'ANNUAL_DEGREE_IMPROVEMENT':

                return new ReportAnnualDegreeImprovement()

            case 'TABLE_TWO':

                return new ReportTableTwo()

            case 'STATISTICAL_REPORT':

                return new ReportStatistical()
        }
    }

}
